"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lincdStorage = exports.ServerFileStore = exports.InMemoryStore = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//import all the exports of this file as one variable called _this (we need this at the end)
const _this = __importStar(require("./lincd-storage"));
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
var loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/lincd-storage.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
exports.ns = (0, NameSpace_1.createNameSpace)('http://lincd.org/ont/lincd-storage');
/**
 * The NamedNode of the ontology itself
 */
exports._self = (0, exports.ns)('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
exports.InMemoryStore = (0, exports.ns)('InMemoryStore');
exports.ServerFileStore = (0, exports.ns)('ServerFileStore');
//An extra grouping object so all the entities can be accessed from the prefix/name
exports.lincdStorage = {
    InMemoryStore: exports.InMemoryStore,
    ServerFileStore: exports.ServerFileStore,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
(0, package_1.linkedOntology)(_this, exports.ns, 'lincd-storage', exports.loadData, '../data/lincd-storage.json');
//# sourceMappingURL=lincd-storage.js.map